/**
 *
 * @author: Matthew Rawson @ 02/10/2017 14:56
 * @description:
 * @notes:
 */
export const DEFAULT = "MODE_DEFAULT"
export const COMPACT = "MODE_COMPACT"
export const FULL_PAGE = "MODE_FULL_PAGE"

export const MODES = [DEFAULT, COMPACT, FULL_PAGE]

export default {DEFAULT, COMPACT, FULL_PAGE, MODES}
